var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.chatPalette.items),function(item,i){return (item)?_c('chat-palette-tile',{key:i,attrs:{"item":item},on:{"click":function($event){_vm.update(item)}}}):_vm._e()}),1)}
var staticRenderFns = []

export { render, staticRenderFns }